function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import React from 'react';
import { useAuthContext } from '@isyc-react/auth/modules/context';
import { NotificationItemType } from '@isyc-react/form/modules/base';
import { useNotificationHubContext } from '@isyc-react/form/modules/context/notification-hub';
import { InputTypeEnum, RhfInputPasswordManager } from '@isyc-react/form/modules/input/manager';
import { useForm } from '@isyc-react/form/modules/rhf';
import { nsnewo } from "../../../i18n/namespaces";
import { nanoid } from 'nanoid';
import { useTranslation } from 'react-i18next';
import { useUserChangePasswordCurrent, useUserValidateReadQueryPromise } from "../../common/api/graphql";
export const PasswordChangeForm = props => {
  const {
    checkString,
    formSize
  } = props;
  // Estado para guardar los valores de los inputs
  const {
    control,
    handleSubmit,
    getValues,
    formState: {
      isValid,
      errors
    }
  } = useForm({
    mode: 'onSubmit',
    defaultValues: {}
  });
  const {
    t
  } = useTranslation(nsnewo.common);
  const [changePassword] = useUserChangePasswordCurrent();
  const userValidate = useUserValidateReadQueryPromise();
  const {
    user
  } = useAuthContext();
  const {
    addNotifications
  } = useNotificationHubContext();
  const onSuccess = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (values) {
      userValidate({
        password: values.oldPassword,
        username: user.username
      }).then(x => {
        if (x.data.user_validate) {
          changePassword({
            variables: {
              pwd: values.newPassword,
              pwdRepeat: values.repeatedPassword
            }
          }).then(y => {
            if (y.errors) {
              addNotifications([{
                key: nanoid().toString(),
                message: t('newo.passworRecovery.error.passwordNoMatch'),
                type: NotificationItemType.ERROR
              }]);
              return;
            }
            if (y.data) {
              addNotifications([{
                key: nanoid().toString(),
                message: t('newo.passworRecovery.success'),
                type: NotificationItemType.SUCCESS
              }]);
            }
          }).catch(() => {
            addNotifications([{
              key: nanoid().toString(),
              message: t('newo.passworRecovery.error'),
              type: NotificationItemType.ERROR
            }]);
          });
        } else {
          addNotifications([{
            key: nanoid().toString(),
            message: t('newo.passworRecovery.error.oldPassword'),
            type: NotificationItemType.ERROR
          }]);
        }
      });
    });
    return function onSuccess(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  const onError = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (errors) {});
    return function onError(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit(onSuccess, onError)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row pb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-4 mb-3"
  }, /*#__PURE__*/React.createElement(RhfInputPasswordManager, {
    inputManagerType: InputTypeEnum.BOTTOM,
    rhf: {
      control,
      name: 'oldPassword',
      rules: {
        required: true
      }
    },
    input: {
      size: formSize,
      label: t('newo.passworRecovery.form.currentPassword'),
      placeholder: t('newo.passworRecovery.form.currentPassword'),
      readOnly: false
    },
    errorMessage: t('newo.passworRecovery.form.missingField')
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-4 mb-3"
  }, /*#__PURE__*/React.createElement(RhfInputPasswordManager, {
    inputManagerType: InputTypeEnum.BOTTOM,
    rhf: {
      control,
      name: 'newPassword',
      rules: {
        required: true,
        validate: {
          validRegexPassword: v => {
            if (checkString) {
              return checkString(v);
            }
            return true;
          }
        }
      }
    },
    input: {
      size: formSize,
      label: t('newo.passworRecovery.form.newPassword'),
      placeholder: t('newo.passworRecovery.form.newPassword'),
      readOnly: false
    },
    errorMessage: t('newo.passworRecovery.form.newPassword.error')
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-4 mb-3"
  }, /*#__PURE__*/React.createElement(RhfInputPasswordManager, {
    inputManagerType: InputTypeEnum.BOTTOM,
    rhf: {
      control,
      name: 'repeatedPassword',
      rules: {
        required: true
      }
    },
    input: {
      size: formSize,
      label: t('newo.passworRecovery.form.repeatedPassword'),
      placeholder: t('newo.passworRecovery.form.repeatedPassword'),
      readOnly: false
    },
    errorMessage: t('newo.passworRecovery.form.missingField')
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 text-center"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-outline-secondary rounded-pill fw-bold px-4 py-2 font-size-15"
  }, t('newo.passworRecovery.form.save'))));
};
export default PasswordChangeForm;